import { useState } from 'react';
import '../styles/UpcomingFormations.css';

const upcomingCourses = [
  {
    title: 'Formation WordPress',
    description: 'Apprenez a creer des sites professionnels avec WordPress, du design a la mise en ligne.'
  },
  {
    title: 'Formation E-commerce',
    description: 'Lancez votre boutique en ligne et maitrisez les bases pour vendre efficacement sur internet.'
  },
  {
    title: 'Formation Closing',
    description: 'Developpez vos competences de vente et de closing pour convertir plus de prospects en clients.'
  }
];

function UpcomingFormations() {
  const [selectedCourse, setSelectedCourse] = useState(null);

  const openForm = (course) => {
    setSelectedCourse(course);
  };

  const closeForm = () => {
    setSelectedCourse(null);
  };

  return (
    <>
      <section className="upcoming-formations" id="formations-avenir">
        <div className="upcoming-container">
          <div className="upcoming-header">
            <span className="section-label">Formations a venir</span>
            <h2 className="upcoming-title">Prochaines formations</h2>
            <p className="upcoming-subtitle">
              De nouvelles formations arrivent bientot pour completer votre parcours.
            </p>
          </div>

          <div className="upcoming-grid">
            {upcomingCourses.map((course) => (
              <article className="upcoming-card" key={course.title}>
                <p className="upcoming-badge">Bientot disponible</p>
                <h3>{course.title}</h3>
                <p>{course.description}</p>
                <button
                  type="button"
                  className="btn btn-primary upcoming-alert-btn"
                  onClick={() => openForm(course)}
                >
                  Ça m'intéresse
                </button>
              </article>
            ))}
          </div>
        </div>
      </section>

      {selectedCourse && (
        <div className="upcoming-modal-overlay" onClick={closeForm}>
          <div className="upcoming-modal" onClick={(event) => event.stopPropagation()}>
            <button
              type="button"
              className="upcoming-modal-close"
              onClick={closeForm}
              aria-label="Fermer"
            >
              ×
            </button>
            <h3>Recevoir une alerte</h3>
            <p className="upcoming-modal-text">
              Laisse ton email et nous te previendrons a l'ouverture de la formation.
            </p>

            <form action="https://formspree.io/f/xjgpwdkz" method="POST" className="upcoming-form">
              <input type="hidden" name="formation" value={selectedCourse.title} />

              <label htmlFor="interest-email">Email</label>
              <input id="interest-email" type="email" name="email" required />

              <label htmlFor="interest-formation">Formation</label>
              <input
                id="interest-formation"
                type="text"
                value={selectedCourse.title}
                readOnly
              />

              <button type="submit" className="btn btn-primary">
                Envoyer
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
}

export default UpcomingFormations;
